import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/lazy';
import Loader from '../../Loader';
import './style.scss';

const VideoScreen = (props) => {
  const { url, videoId, isFetching, refresh } = props;

  if (isFetching || !url) {
    return (
      <div className="video-loader-wrap">
        <Loader dark fill />
      </div>
    );
  }

  return (
    <div className="video-wrap embed-responsive-item">
      <ReactPlayer
        key={refresh}
        id="primary-feed"
        className="embed-responsive-item"
        url={url}
        width="100%"
        height="100%"
        controls
        playing
        config={{
          youtube: {
            playerVars: { modestbranding: 0, showinfo: 1 },
          },
        }}
      />
    </div>
  );
};

VideoScreen.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  refresh: PropTypes.number.isRequired,
  url: PropTypes.string,
};

VideoScreen.defaultProps = {
  url: '',
};

export default VideoScreen;
